import { SativaHybridIndicaSectionRowViewModel } from './sativa-hybrid-indica-section-row-view-model';

export class SativaHybridIndicaCols {
  constructor(
    sativa: SativaHybridIndicaSectionRowViewModel[],
    hybrid: SativaHybridIndicaSectionRowViewModel[],
    indica: SativaHybridIndicaSectionRowViewModel[]
  ) {
    this.sativa = sativa;
    this.hybrid = hybrid;
    this.indica = indica;
  }

  sativa: SativaHybridIndicaSectionRowViewModel[] = [];
  hybrid: SativaHybridIndicaSectionRowViewModel[] = [];
  indica: SativaHybridIndicaSectionRowViewModel[] = [];
}
